import './vendor';
import './components/profilePhotoApp';
import './components/twoFactorAuthenticationProfileApp';
import './noteable';
import 'xss';

jQuery(function ($) {
    var $body = $('body');

    // Handle checkbox selectors on columns
    $body.on('click', 'table th input.master', function (event) {
        var slaves = $(this).parents('table').find('input.slave:not([disabled])');
        slaves.prop('checked', $(this).prop('checked'));
    });

    $body.on('click', 'table td input.slave', function (event) {
        if (!$(this).prop('checked')) {
            $(this).parents('table').find('input.master').prop('checked', false);
        }
    });

    // Initiate popovers
    $('[data-toggle="popover"]').popover({ html: true });

    // Initiate datepickers
    $('.input-daterange.pretty-date input').datepicker({ format: 'M d, yyyy', autoclose: true });

    // Initiate datepickers
    $('.input-daterange input').datepicker({ format: 'yyyy-mm-dd', autoclose: true });

    // Initiate datepickers
    $('.datepicker').datepicker({ format: 'M d, yyyy', autoclose: true });

    var $body = $('body');

    // Handle checkbox selectors on columns
    $body.on('click', 'table th input.master', function (event) {
        var slaves = $(this).parents('table').find('input.slave:not([disabled])');
        slaves.prop('checked', $(this).prop('checked'));
    });

    $body.on('click', 'table td input.slave', function (event) {
        if (!$(this).prop('checked')) {
            $(this).parents('table').find('input.master').prop('checked', false);
        }
    });

    // Initiate popovers
    $('[data-toggle="popover"]').popover({ html: true });

    // Initiate datepickers
    $('.input-daterange.pretty-date input').datepicker({ format: 'M d, yyyy', autoclose: true });

    // Initiate datepickers
    $('.input-daterange input').datepicker({ format: 'yyyy-mm-dd', autoclose: true });

    // Initiate datepickers
    $('.datepicker').datepicker({ format: 'M d, yyyy', autoclose: true });

    // Initiate colour pickers
    $('.colourpicker').each(function () {
        var input = $(this).prop('type', 'hidden');
        var button = $('<div/>').insertAfter(input);
        var pickr = Pickr.create({
            el: button[0],
            theme: 'nano',
            default: input.val() || '#337ab7',
            lockOpacity: true,
            comparison: false,
            swatches: ['#F056AD', '#85C7EE', '#60f056', '#fe3b59', '#ffc548', '#82d761', '#337ab7'],
            components: {
                preview: false,
                opacity: false,
                hue: true,
                interaction: {
                    input: true,
                    clear: true,
                },
            },
        })
            .on('change', (color) => {
                input.val(color.toHEXA().toString(0));
            })
            .on('save', (color) => {
                input.val(color.toHEXA().toString(0));
                pickr.hide();
            });

        $(this).data('pickr', pickr);
    });

    // Initiate a simple selectize instance
    $('select.simple-selectize').selectize({
        create: false,
        lockOptgroupOrder: true,
        sortField: 'text',
    });

    // Initiate a simple selectize instance
    $('select.create-selectize').selectize({
        create: true,
        createOnBlur: true,
        sortField: 'text',
    });

    // Initiate a simple selectize instance
    $('select.urls-selectize').selectize({
        create: true,
        createOnBlur: true,
        sortField: 'text',
        plugins: ['remove_button'],
        render: {
            item: function (item, escape) {
                return (
                    '<div><a href="' +
                    item.text +
                    '" target="_blank"><i class="fa fa-external-link"></i></a> ' +
                    escape(item.text) +
                    '</div>'
                );
            },
        },
    });

    // Initialize a tags selectize instance
    $('.selectize-tags').selectize({
        create: true,
        persist: true,
        createOnBlur: true,
        plugins: ['remove_button'],
    });

    function elementHasValue($el) {
        let inputNotEmpty = false;
        const $input = $el.find('input.form-control,select.form-control');
        const $selectize = $el.find('.selectize.form-control,.locally-selectize.form-control');

        if ($selectize.length > 0) {
            if ($selectize.data('selectize') && $selectize.data('selectize').getValue().length > 0) {
                return true;
            } else {
                return false;
            }
        }

        $input.each(function () {
            var usingDefaultOption = $(this).is('select') && $(this).find('option:selected').index() === 0;

            if ($(this).val() !== '' && !usingDefaultOption) {
                inputNotEmpty = true;
            }
        });

        return inputNotEmpty;
    }

    function hideRelevantFilters() {
        $('.more-field').each(function (i, el) {
            const $el = $(el);
            if (!elementHasValue($el)) {
                $el.addClass('hide');
            } else {
                $el.removeClass('hide');
            }
        });
    }

    $('.toggle-more-fields').on('click', function (ev) {
        ev.preventDefault();

        var $this = $(this);

        if ($this.data('switch') == undefined) {
            $this.data('switch', false);
        }

        // hide
        if ($this.data('switch')) {
            // only hide those with no value set
            hideRelevantFilters();
            $this.html('More Filters').data('switch', false);

            // show
        } else {
            $('.more-field').removeClass('hide');
            $this.html('Less Filters').data('switch', true);
        }
    });

    hideRelevantFilters();

    $('select.multi-selectize').selectize({
        create: false,
        maxItems: null,
    });

    // generic bootstrap validation
    /*$('.bs-validate').bootstrapValidator({
		exclude: ['.bs-ignore'],
	    feedbackIcons: {
	        valid: 'glyphicon glyphicon-ok',
	        invalid: 'glyphicon glyphicon-remove',
	        validating: 'glyphicon glyphicon-refresh'
	    }
	});*/

    if ($('.form-ajax').length === 1)
        $.ctrlS(function () {
            $('.form-ajax').fire('submit');
        });

    $('.form-ajax').submit(function (ev) {
        ev.preventDefault();

        var $form = $(this);

        $form.find('button[type=submit]').each(function (i, btn) {
            $btn = $(btn);

            $btn.addClass('disabled')
                .attr('disabled', 'disabled')
                .data('originalHtml', $btn.html())
                .html('<i class="fa fa-circle-o-notch fa-spin"></i>');
        });

        var enableButtons = function () {
            $form.find('button[type=submit]').each(function (i, btn) {
                $btn = $(btn);
                $btn.removeClass('disabled').removeAttr('disabled').html($btn.data('originalHtml'));
            });
        };

        var success = function (json) {
            toastr.success($form.data('success') ? $form.data('success') : 'Success!');
        };

        var error = function (response) {
            toastr.error(
                ($form.data('error') ? $form.data('error') : 'Error!') + '<br>' + response.responseJSON.error.message
            );
        };

        $.ajax({
            type: $form.attr('method'),
            url: $form.attr('action'),
            data: $form.serializeArray(),
            success: success,
            error: error,
            dataType: 'json',
        }).always(function () {
            enableButtons();
        });
    });

    $('.new-contact').click(function (ev) {
        ev.preventDefault();

        var $this = $(this);
        var $modal = $('#create-contact-modal');

        // if data-client-id is provided, set client id in the modal
        if ($this.data('clientId')) {
            $modal.on('shown.bs.modal', function () {
                $modal.find('select[name=client_id]')[0].selectize.setValue($this.data('clientId'));
            });
        }

        $modal.modal();
    });

    $('.new-site').click(function (ev) {
        ev.preventDefault();

        var $this = $(this);
        var $modal = $('#create-site-modal');

        // if data-client-id is provided, set client id in the modal
        if ($this.data('clientId')) {
            $modal.on('shown.bs.modal', function () {
                $modal.find('select[name=client_id]')[0].selectize.setValue($this.data('clientId'));
            });
        }

        $('#create-site-modal').modal();
    });

    $('.new-client').click(function (ev) {
        ev.preventDefault();
        $('#create-client-modal').modal();
    });

    $('#create-contact').submit(function (ev) {
        ev.preventDefault();

        var $modal = $('#create-contact-modal');
        var $form = $(this);

        $.modalLoaderShow($modal);

        $.post('/api/contacts/add', $form.serializeArray(), function (contact) {
            $.modalLoaderHide($modal);
            $modal.modal('hide');
            $.clearForm($form);
            toastr.success(contact.first_name + ' ' + contact.last_name + ' created successfully!');
        });
    });

    $('.noteable').noteable();

    $('#global-search').selectize({
        labelField: 'name',
        valueField: 'permalink',
        sortField: 'name',
        searchField: ['id', 'name', 'sites_index', 'site_domains_index', 'contacts_index'],
        create: false,
        load: function (query, callback) {
            if (!query.length) return callback();
            axios
                .get('/autocomplete/clients?query=' + encodeURIComponent(query))
                .then(function (res) {
                    callback(res.data);
                })
                .catch(function (err) {
                    callback();
                });
        },
        render: {
            option: function (item, escape) {
                return `
                    <div class="py-1 px-2 leading-snug">
                        <div class="font-bold text-base">
                            ${escape(item.name)} <small class="text-muted">(ID: ${escape(item.id)})</small>
                            ${
                                item.partner_id > 1
                                    ? `<span class="inline-block items-center align-top mt-1 px-2 py-0 rounded text-xs font-medium leading-4 bg-gray-300 text-gray-800">${escape(
                                          item.partner_name
                                      )}</span>`
                                    : ''
                            }
                        </div>
                        <small class="text-muted">
                            ${
                                item.subscription_amount
                                    ? `${escape(item.subscription_amount)} <small>${escape(
                                          item.subscription_currency
                                      )}</small>`
                                    : ''
                            }
                            &nbsp;&nbsp;&nbsp; GDV: $${escape(item.gdv)} &nbsp;&nbsp; GDV(60d): $${escape(item.gdv_60d)}
                        </small>
                    </div>
                `;
            },
        },
        onChange: function (value) {
            window.location.href = value;
        },
        onDropdownOpen: function ($dropdown) {
            $dropdown.css('visibility', this.lastQuery.length ? 'visible' : 'hidden');
        },
        onType: function (value) {
            if (value === '') {
                this.close();
            }
        },
    });
});

$.modalLoaderShow = function ($modal) {
    $modal.find('.modal-body, .modal-footer').hide();
    $modal
        .find('.modal-body')
        .before($('<div class="modal-loader"><i class="fa fa-circle-o-notch fa-spin fa-3x"></i></div>'));
};

$.modalLoaderHide = function ($modal) {
    $modal.find('.modal-body, .modal-footer').show();
    $modal.find('.modal-loader').remove();
};

$.clearForm = function ($form) {
    $form.find('input, select, textarea').val('');
};

$.ctrlS = function (callback) {
    $(document).bind('keydown', function (e) {
        // MAC INSANTITY - This isn't working on mac... #TODO
        if (
            (e.ctrlKey || e.charCode === 91 || e.charCode === 93 || e.charCode === 224 || e.charCode === 17) &&
            e.which == 83
        ) {
            e.preventDefault();
            callback(e);
            return false;
        }
    });
};

window.confirmationModal = function ({ title, message, confirmButtonText, confirmCallback }) {
    const element = $(`
        <div class="modal fade" tabindex="-1" role="dialog">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header alert-danger rounded-t">${title}</div>
                    <div class="modal-body">${message}</div>
                    <div class="modal-footer">
                        <button class="btn bg-red-500 text-white transition-all duration-300" data-dismiss="modal">Cancel</button>
                        <button class="btn hover:bg-gray-100 border border-gray-200 transition-all duration-300" data-okay="modal">${confirmButtonText ?? 'Yes'}</button>
                    </div>
                </div>
            </div>
        </div>
    `);

    element.on('click', '[data-dismiss]', function () {
        element.modal('hide');
    });

    element.on('click', '[data-okay]', async function () {
        element.find('button').addClass('opacity-50');
        element.find('button').attr('disabled', 'disabled');

        await confirmCallback();

        element.modal('hide');
        element.find('button').removeClass('opacity-50');
        element.find('button').removeAttr('disabled');
    });

    element.modal();
};

window.ladda = {
    create: function (element) {
        if (typeof element === 'string') {
            element = document.querySelector(element);
        }
        if (element) {
            return (element.ladda = element.ladda || Ladda.create(element));
        }
    },
    start: function (element) {
        var btn = ladda.create(element);
        if (btn) {
            btn.start();
            var progress = 0;
            var interval = setInterval(function () {
                progress = Math.min(progress + Math.random() * 0.05, 1);
                btn.setProgress(progress);
                if (progress === 1 && interval) {
                    clearInterval(interval);
                }
            }, 200);
        }
        return btn;
    },
    stop: function (element) {
        var btn = ladda.create(element);
        if (btn) {
            if (btn.interval) clearInterval(btn.interval);
            btn.stop();
        }
        return btn;
    },
};

window.embedModeAnalytics = (function () {
    function generateUUID() {
        var d = new Date().getTime();
        var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = (d + Math.random() * 16) % 16 | 0;
            d = Math.floor(d / 16);
            return (c == 'x' ? r : (r & 0x7) | 0x8).toString(16);
        });
        return uuid;
    }

    return function ($element, href) {
        var id = generateUUID();
        var reportId = href.match(/reports\/(.*?)\//)[1];
        var iframe = document.createElement('iframe');
        var query = 'resize=true&embed_id=' + id;
        var url = href.indexOf('?') > 0 ? href + '&' + query : href + '?' + query;

        iframe.src = url;
        iframe.style.border = 'none';
        iframe.style.width = '100%';
        iframe.style.height = '300px';
        iframe.id = id;
        iframe.setAttribute('data-report', reportId);
        $element.append(iframe);

        var onmessage = (function (id) {
            return function (event) {
                event || (event = window.event);
                if (event.data && event.data.id === id) {
                    // footer = 24 height + 1 border | iframe = 2 border
                    // Find the element again since if a framework like angular compiles our iframe, we'll be pointing to a placeholder frame
                    document.getElementById(id).style.height = event.data.height * 1 + (2 + 24) + 'px';
                }
            };
        })(id);

        if (window.addEventListener) {
            window.addEventListener('message', onmessage, false);
        } else {
            window.attachEvent('onmessage', onmessage);
        }
    };
})();
